module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/BrandVidawool-3d8fab5a9eeda39bad70565868f32601.svg";